import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <>
    <path
      d="M278.307-263.242H258.4a.581.581,0,0,0-.545.612v2.558a.583.583,0,0,0,.545.619h19.9a.587.587,0,0,0,.551-.619v-2.558A.585.585,0,0,0,278.307-263.242Zm-16.232,1.894a1.108,1.108,0,0,1-1.107,1.108,1.108,1.108,0,0,1-1.108-1.108,1.108,1.108,0,0,1,1.108-1.107A1.107,1.107,0,0,1,262.075-261.348Zm14.771,0a1.108,1.108,0,0,1-1.107,1.108,1.108,1.108,0,0,1-1.108-1.108,1.108,1.108,0,0,1,1.108-1.107A1.107,1.107,0,0,1,276.846-261.348Z"
      transform="translate(-257.859 264.248)"
    />
    <path
      d="M278.376-253.853H258.341a.479.479,0,0,0-.482.477v9.575a.479.479,0,0,0,.482.477h20.035a.479.479,0,0,0,.482-.477v-9.575A.479.479,0,0,0,278.376-253.853Zm-15.571,4.661H259.13v-3.342h3.676Zm4.867,0H264v-3.342h3.676Zm4.973,4.486h-3.681v-3.342h3.681Zm0-4.486h-3.681v-3.342h3.681Zm4.931,4.486H273.9v-3.342h3.675Z"
      transform="translate(-257.859 259.831)"
    />
    <path
      d="M1.142,0H2.154A1.142,1.142,0,0,1,3.3,1.142v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A1.142,1.142,0,0,1,1.142,0Z"
      transform="translate(1.461 0)"
    />
    <path
      d="M1.142,0H2.154A1.142,1.142,0,0,1,3.3,1.142v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A1.142,1.142,0,0,1,1.142,0Z"
      transform="translate(16.232 0)"
    />
  </>,
  '0 0 20.999 16.507'
);
